module.exports = __webpack_public_path__ + "static/media/stoodiologo.175eeac4.svg";